import { VerifyQuestion } from "./verify-question";

export class VerifyPick {
    constructor(public questionType: string, 
                public questionAnswer: string) 
      { }
  }